<div class="social-proof" [class.social-proof-hide]="hideSavingsPlan">
  <div class="social-proof-graph" *ngIf="kind !== '3a' && !hideSavingsPlan">
    <div class="social-demo">
      <div class="social-demo-tooltip" [style.left]="knobPosition">
        {{ 'sp.revamp.socialProof.avg' | translate: { avg: savingsPlanSocialProof?.average | translateNumber: language:currency } }}
      </div>
      <div class="social-demo-knob" [style.left]="knobPosition"></div>
    </div>
    <p
      [innerHTML]="
        'sp.revamp.socialProof.description'
          | translate
            : {
                percentage: savingsPlanSocialProof?.percentage | percent: '1.0-1',
                below_avg: savingsPlanSocialProof?.below_average | translateNumber: language:currency,
                above_avg: savingsPlanSocialProof?.above_average | translateNumber: language:currency
              }
      "
    ></p>
  </div>
  <div class="social-proof-expand" id="social-proof-expand">
    <a href="javascript:;" (click)="onToggleDetails()">{{
      (showDetails ? 'sp.revamp.assetGraph.expand' : 'sp.revamp.assetGraph.collapse') | translate
    }}</a>
  </div>
  <div *ngIf="showDetails" class="social-proof-details">
    <h3 class="ui-headline">{{ 'sp.revamp.assetGraph.legend.title' | translate }}</h3>
    <p
      [innerHTML]="
        (kind === '3a' ? 'sp.revamp.3a.legend.summary' : 'sp.revamp.assetGraph.legend.difference')
          | translate
            : {
                years: estimatedPeriod,
                difference: difference | translateNumber: language:currency
              }
      "
    ></p>
    <p
      [innerHTML]="
        'sp.revamp.assetGraph.legend.probability'
          | translate
            : {
                loss: expectedPercentages.loss | percent: '1.0-1',
                gain: expectedPercentages.good | percent: '1.0-1',
                expected: expectedPercentages.expected | percent: '1.0-1'
              }
      "
    ></p>
    <div class="social-proof-calculation">
      <h4 class="ui-headline">
        <img src="/assets/images/icn.svg" alt="Assets Info Icon" />
        {{ 'sp.revamp.assetGraph.legend.subtitle' | translate }}
      </h4>
    </div>
    <p>{{ 'sp.revamp.assetGraph.legend.model' | translate }}</p>
  </div>
</div>
